import axios, { AxiosPromise } from 'axios';

import { ETypUdalosti } from 'enums/akcionarKorpAkce/typUdalosti';

export interface IEmiseKorpAkce {
    sezemise: ISezemiseKorpAkce[];
}
export interface ISezemiseKorpAkce {
    isin: string;
    nazevemise: string;
    lei: string;
}
const kontrolaXMLApi = (
    id: string | number,
    tempnazev: string,
    fileName: string,
    typudalosti?: ETypUdalosti | null,
    datumzverejneni?: string | null,
    idSRD?: number | string
): AxiosPromise<{ datum: string; upozor: { typ: string }[] }> | null => {
    if (!fileName || !typudalosti) return null;
    return axios({
        method: 'PUT',
        url: `SRD/${id}/KontrolaXML`,
        data: {
            datumzverejneni,
            tmp: tempnazev,
            nazevsouboru: fileName,
            typudalosti,
            id: idSRD
        }
    });
};

export const kontrolaXMLApiCert = (
    id: string | number,
    tempnazev: string,
    fileName: string,
    typudalosti?: ETypUdalosti | null,
    datumzverejneni?: string | null,
    idSRD?: number | string
): AxiosPromise<{ datum: string; upozor: { typ: string }[] }> | null => {
    if (!fileName || !typudalosti) return null;
    return axios({
        method: 'PUT',
        url: `SRD/KontrolaXML/Cert/${id}`,
        data: {
            datumzverejneni,
            tmp: tempnazev,
            nazevsouboru: fileName,
            typudalosti,
            id: idSRD
        }
    });
};
export default kontrolaXMLApi;
